module.exports = __webpack_public_path__ + "media/images/bet__bg--xco-d718e7e4fcdfa6c424edb74150399f56.jpg";